import type { FC } from 'react'
import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronLeftIcon } from '@segment/matcha/components/Icons/Common'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

interface LegalHeroProps {
  title: string
}

const Hero: FC<LegalHeroProps> = ({ title }) => {
  const pageConfig = usePageConfig()
  const theme = useTheme()
  const isContentPage = title !== `Legal`
  return (
    <Wrapper>
      <StyledHeroBase variant="2Col">
        <HeroRecipe.Copy>
          {isContentPage && (
            <ButtonText
              tag="a"
              href={getAbsoluteUrl(`/legal`, pageConfig)}
              color={theme.palette.neutrals.white[100]}
              iconStart={ChevronLeftIcon}
            >
              Legal Resources
            </ButtonText>
          )}
          <CopyText.Heading variant="h1" tag="h1">
            {title}
          </CopyText.Heading>
        </HeroRecipe.Copy>
      </StyledHeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.brand.darkAcai[700]};
`

const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    text-align: left;
    padding-bottom: 80px;
    grid-template-columns: minmax(50%, 940px);
    justify-content: flex-start;
    gap: 0;
  }
`

export default Hero
